import React, { useEffect, useState } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"

import { useAuth } from "../contexts/AuthContext"
import { isTokenExpired, clearAuthData } from "../utils/token-utils"

import "./Header.sass"

function UserProfile() {
  const { user } = useAuth()

  return user ? (
    <div id="user-profile-logged">
      <div>
        <span className="font text-3">{user.name}</span>
      </div>
      <Link to="/logout">
        <div className="logout-action">
          <span className="font text-3">Sair</span>
          <img src="/assets/icons/sign-out.svg" alt="" className="icon" />
        </div>
      </Link>
    </div>
  ) : (
    <Link to="/login">
      <div id="user-profile" className="login-action">
        <span className="font text-3">Entrar</span>
      </div>
    </Link>
  )
}

function Header() {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Rotas públicas onde não devemos verificar expiração do token
    const publicRoutes = ["/login", "/register"]
    const isPublicRoute = publicRoutes.includes(location.pathname)

    // Verifica expiração imediatamente (apenas em rotas protegidas)
    const checkExpiration = () => {
      // Não verifica expiração em rotas públicas
      if (isPublicRoute) {
        return
      }

      if (isTokenExpired()) {
        clearAuthData()
        logout()
        navigate("/login")
      }
    }

    // Verifica na montagem do componente
    checkExpiration()

    // Verifica a cada 1 minuto para detectar expiração
    const interval = setInterval(checkExpiration, 60 * 1000)

    return () => {
      clearInterval(interval)
    }
  }, [logout, navigate, location.pathname])

  return (
    <>
      <div id="header">
        <div id="first">
          <Link to="/incident">
            <span className="text-10 font">
              <strong>
                <img src="/assets/images/logo.png" alt="" />
              </strong>
            </span>
          </Link>
          <Link to="/incident">
            <span className="text-3 font">Portal do Cliente</span>
          </Link>
        </div>
        <div id="second">
          <UserProfile />
        </div>
      </div>
    </>
  )
}

export default Header
